import Icon1 from '@/images/our-benefits/people-4.png';
import Icon2 from '@/images/our-benefits/cart-3.png';
import Icon3 from '@/images/our-benefits/tools4.png';
import Image from 'next/legacy/image';

const features = [
  {
    name: 'EnergyPal Is Unbiased, Expert Advice',
    description:
      'We start by assigning you a dedicated EnergyPal Advisor, who will understand your home energy needs, answer your questions, and run our proprietary recommendation engine to deliver you best-fit solutions, at best value pricing.   Our process is quick, easy, and saves you tons of time in making the right decisions.',
    icon: Icon1,
  },
  {
    name: 'One-Stop-Shop For Comparative Quotes',
    description: `EnergyPal provides you choice, sourcing a  wide selection of only top-quality energy solutions, and helping you compare the costs and benefits. You won't need to deal with pushy sales folks from many companies.  We handle all that and make your experience joyful.`,
    icon: Icon2,
  },
  {
    name: 'Worry-Free Professional Installation',
    description: `You can relax knowing that experienced, licensed professionals will expertly install your system, and make sure everything is working properly. You're covered with  included warranties and EnergyPal's added layer of oversight.`,
    icon: Icon3,
  },
];

export default function OurBenefits() {
  return (
    <div className="relative py-8 bg-gray-200 sm:py-12 lg:py-20">
      <div className="max-w-md px-4 mx-auto text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        {/* <h2 className="text-base font-semibold tracking-wider uppercase text-primary-600">Deploy faster</h2> */}
        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Our benefits for even greater protection
        </h2>
        <p className="mx-auto mt-5 text-xl text-gray-500 max-w-prose">
          EnergyPal reinvented solar shopping. We make it easy for you, provide
          the best deals and ensure you&apos;re happy with your choice.
        </p>
        <div className="mt-12">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="flow-root px-6 py-8 text-left bg-white rounded-lg"
              >
                <div className="">
                  <div className="flex items-center w-12 h-12 rounded-md text-primary">
                    <Image
                      src={feature.icon}
                      alt={feature.name}
                      quality={100}
                    />
                  </div>
                  <h3 className="my-3 text-2xl font-semibold tracking-tight text-gray-900">
                    {feature.name}
                  </h3>
                  <p className="mt-5 text-base text-gray-500">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
